(function () {
  'use strict';

  var CART_JS = '/cart.js';
  var CART_CHANGE_JS = '/cart/change.js';

  // { groupId: { parentKey, children: [{key, pricing}] } }
  var groupMap = {};
  var syncInProgress = false;

  // ---- スタイル注入 ----
  // .drawer .cart__remove { display:none } を上書きし、
  // カートページとドロワーカートで削除リンクを統一表示する

  function injectStyles() {
    var style = document.createElement('style');
    style.textContent = [
      /* ドロワー内で非表示になっている削除リンクを表示 */
      '.drawer .cart__remove { display: block !important; }',
      /* カートページ・ドロワー共通スタイル */
      '.cart__remove a {',
      '  display: inline-block;',
      '  font-size: 11px;',
      '  color: #999;',
      '  text-decoration: underline;',
      '  margin-top: 6px;',
      '  cursor: pointer;',
      '}',
      '.cart__remove a:hover { color: #c00; }',
      /* オプション商品の数量ラベル */
      '.kpw-option-qty {',
      '  font-size: 12px;',
      '  color: #555;',
      '  margin-top: 4px;',
      '}'
    ].join(' ');
    document.head.appendChild(style);
  }

  // ---- Cart API helpers ----

  function fetchCart() {
    return fetch(CART_JS, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  function cartChange(key, qty) {
    return fetch(CART_CHANGE_JS, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  // 子削除時・孤立親検出時に親の properties をクリアする
  // /cart/change.js は properties: {} で全プロパティをクリアできる（quantity は維持）
  function cartClearProperties(key) {
    return fetch(CART_CHANGE_JS, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, properties: {} })
    }).then(function (r) { return r.json(); });
  }

  // ---- Group map ----

  function buildGroupMap(items) {
    groupMap = {};

    items.forEach(function (item) {
      var props = item.properties || {};
      var group = props['_kpw_group'];
      if (!group) return;

      if (!groupMap[group]) {
        groupMap[group] = { parentKey: null, children: [] };
      }

      if (props['_kpw_role'] === 'option') {
        groupMap[group].children.push({
          key: item.key,
          pricing: props['_pricing'] || 'fixed'
        });
      } else {
        groupMap[group].parentKey = item.key;
      }
    });

    // 親のないグループを除去
    Object.keys(groupMap).forEach(function (g) {
      if (!groupMap[g].parentKey) delete groupMap[g];
    });
  }

  function getAllChildKeys() {
    var keys = [];
    Object.keys(groupMap).forEach(function (g) {
      groupMap[g].children.forEach(function (c) { keys.push(c.key); });
    });
    return keys;
  }

  // ---- DOM: 子アイテムの数量UIをロック ----
  // 子の数量は親に連動するため操作不可にする。
  // 削除ボタン（.cart__remove）は残す（子単独削除を許可するため）

  function lockChildControls() {
    var childKeys = getAllChildKeys();

    childKeys.forEach(function (key) {
      var row = document.querySelector('[data-hulkapps-lineitem][data-key="' + key + '"]');
      if (!row) return;

      var qtyWrapper = row.querySelector('.js-qty__wrapper');
      if (qtyWrapper) {
        qtyWrapper.style.visibility = 'hidden';
        qtyWrapper.style.pointerEvents = 'none';
      }
      // .cart__remove は非表示にしない → 子単独削除を許可
    });
  }

  // ---- 孤立アイテムを検出・修復 ----
  //
  // 孤立した子（orphan child）: 対応する親が存在しない → 削除
  // 孤立した親（orphan parent）: 対応する子が存在しない → properties をクリア
  //   ※ 顧客が子（companionバリアント）を単独削除すると、親に
  //      「マット冷凍処理」「_kpw_group」プロパティが残存するため
  //      注文データに不要なプロパティが付く問題を防ぐ

  function cleanOrphans(items) {
    // グループごとに親・子の有無を確認
    var parentGroups = {};
    var childGroups = {};

    items.forEach(function (item) {
      var props = item.properties || {};
      var group = props['_kpw_group'];
      if (!group) return;

      if (props['_kpw_role'] === 'option') {
        childGroups[group] = true;
      } else {
        parentGroups[group] = true;
      }
    });

    var orphanChildDeletes = [];
    var orphanParentClears = [];

    items.forEach(function (item) {
      var props = item.properties || {};
      var group = props['_kpw_group'];
      if (!group) return;

      if (props['_kpw_role'] === 'option') {
        // 孤立した子: 親がカートにいない → 削除
        if (!parentGroups[group]) {
          orphanChildDeletes.push(cartChange(item.key, 0));
        }
      } else {
        // 孤立した親: 子がカートにいない → properties クリア
        // （子単独削除後に残った冷凍処理プロパティを除去）
        if (!childGroups[group]) {
          orphanParentClears.push(cartClearProperties(item.key));
        }
      }
    });

    var hasCleanup = orphanChildDeletes.length > 0 || orphanParentClears.length > 0;

    if (hasCleanup) {
      Promise.all(orphanChildDeletes.concat(orphanParentClears)).then(function () {
        window.location.reload();
      });
      return true;
    }
    return false;
  }

  // ---- 削除リンクのクリックを完全にAJAX化 ----
  //
  // 対象: カートページ・ドロワーカートの全 line item
  // 動作:
  //   親商品（_kpw_group 持ちかつ _kpw_role !== 'option'）→ 親 + 子を全削除
  //   子オプション商品 → 子を削除 + 親の properties をクリア（冷凍処理プロパティ除去）
  //   通常商品 → その1件だけ削除
  //
  // document 委譲なので、AJAX 再描画後も有効

  function interceptDeleteLinks() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest ? e.target.closest('.cart__remove a') : null;
      if (!link) return;

      var row = link.closest('[data-hulkapps-lineitem]');
      if (!row) return;

      var itemKey = row.dataset.key;
      if (!itemKey) return;

      e.preventDefault();
      e.stopPropagation();

      // 親商品かどうか確認（同グループの子が存在するか）
      var childKeys = [];
      Object.keys(groupMap).forEach(function (g) {
        if (groupMap[g].parentKey === itemKey) {
          groupMap[g].children.forEach(function (c) { childKeys.push(c.key); });
        }
      });

      // 子商品かどうか確認（削除時に親の properties をクリアするため）
      var parentKeyToClear = null;
      if (childKeys.length === 0) {
        Object.keys(groupMap).forEach(function (g) {
          groupMap[g].children.forEach(function (c) {
            if (c.key === itemKey) {
              parentKeyToClear = groupMap[g].parentKey;
            }
          });
        });
      }

      // 削除リスト: 親 + 子（存在する場合）/ 子・通常商品は単体
      var deletes = [cartChange(itemKey, 0)];
      childKeys.forEach(function (k) { deletes.push(cartChange(k, 0)); });

      // 子を削除するとき、親の冷凍処理プロパティもクリアする
      // （親に _kpw_group + オプションプロパティが残存して注文に混入するのを防ぐ）
      var clearParentPromise = parentKeyToClear
        ? Promise.all(deletes).then(function () { return cartClearProperties(parentKeyToClear); })
        : Promise.all(deletes);

      clearParentPromise
        .then(function () { window.location.reload(); })
        .catch(function () { window.location.reload(); });
    });
  }

  // ---- 数量同期チェック ----

  function getSyncUpdates(items) {
    var itemMap = {};
    items.forEach(function (item) { itemMap[item.key] = item; });

    var updates = [];

    Object.keys(groupMap).forEach(function (g) {
      var entry = groupMap[g];
      var parent = itemMap[entry.parentKey];
      if (!parent) return;

      entry.children.forEach(function (child) {
        var childItem = itemMap[child.key];
        if (!childItem) return;

        // percentage は ¥1×保証金額 方式のため数量連動しない（上書き禁止）
        if (child.pricing === 'percentage') return;

        var expectedQty = parent.quantity;
        if (childItem.quantity !== expectedQty) {
          updates.push({ key: child.key, qty: expectedQty });
        }
      });
    });

    return updates;
  }

  // ---- メイン初期化 ----

  function init() {
    fetchCart().then(function (cart) {
      var items = cart.items || [];

      buildGroupMap(items);
      lockChildControls();

      if (cleanOrphans(items)) return; // 孤立削除中 → reload するので以降不要

      interceptDeleteLinks();

      // 初期ロード時に数量ずれがあれば修正
      var initialUpdates = getSyncUpdates(items);
      if (initialUpdates.length > 0) {
        syncInProgress = true;
        Promise.all(initialUpdates.map(function (u) { return cartChange(u.key, u.qty); }))
          .then(function () { window.location.reload(); })
          .catch(function () { syncInProgress = false; });
      }
    });

    // テーマの AJAX カート更新後に子数量を同期
    // cart:updated はカートページ・ドロワー両方の CartForm から発火される
    document.addEventListener('cart:updated', function () {
      if (syncInProgress) return;

      // テーマの DOM 再描画が完了するまで待機
      setTimeout(function () {
        fetchCart().then(function (cart) {
          var items = cart.items || [];

          buildGroupMap(items);
          lockChildControls();

          var updates = getSyncUpdates(items);
          if (updates.length === 0) return;

          syncInProgress = true;
          Promise.all(updates.map(function (u) { return cartChange(u.key, u.qty); }))
            .then(function () { window.location.reload(); })
            .catch(function () { syncInProgress = false; });
        });
      }, 300);
    });
  }

  // ---- Boot ----
  // CartPageForm  = /cart ページのフォーム
  // CartDrawerForm = ドロワーカートのフォーム（drawer 有効時は全ページに存在）

  function boot() {
    injectStyles(); // CSS 注入は DOM 依存なしで即時実行

    if (document.getElementById('CartPageForm') || document.getElementById('CartDrawerForm')) {
      init();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();
